// Note-based clinics use the existing markdown viewer and release controls.
const API_CONCEPT_CLINICS = [
  {
    id: 'fs-api-01-http-contracts-java-python',
    title: 'API Clinic 01 · HTTP, JSON & Java/Python Contracts',
    topics: ['Client/server', 'HTTP requests', 'JSON and DTOs', 'Status codes', 'Failure diagnosis'],
    file: null,
    kind: 'note',
    track: 'full-stack-developer-job-ready',
    cohort: 1,
    active: true,
    date: null,
    resources: [
      { label: 'Detailed API concept clinic', ctaLabel: 'Open concept clinic', href: '/data/guides/fs-api-concept-clinic.md', modal: 'markdown', cardCta: true },
      { label: 'Worked cases and cohort practice', href: '/data/guides/fs-api-clinic-practice.md', modal: 'markdown' },
      { label: 'Python + Java study workbook', href: '/data/guides/fs-api-python-java-study.md', modal: 'markdown' },
      { label: 'Facilitator notes and answer key', href: '/data/guides/fs-api-clinic-facilitator.md', modal: 'markdown', locked: true },
    ],
  },
  {
    id: 'fs-api-02-java-spring-boot',
    title: 'API Clinic 02 · Java & Spring Boot Explained',
    topics: ['JDK/JVM/Maven', 'Spring versus Boot', 'Controllers and annotations', 'Beans and constructor injection', 'Validation and errors'],
    file: null,
    kind: 'note',
    track: 'full-stack-developer-job-ready',
    cohort: 1,
    active: true,
    date: null,
    resources: [
      { label: 'Spring Boot concept clinic', ctaLabel: 'Open Spring Boot clinic', href: '/data/guides/fs-api-concept-clinic.md#clinic-2-java-and-spring-boot', modal: 'markdown', cardCta: true },
      { label: 'Worked cases and cohort practice', href: '/data/guides/fs-api-clinic-practice.md', modal: 'markdown' },
      { label: 'Full runnable Task API workbook', href: '/data/guides/fs-api-python-java-study.md', modal: 'markdown' },
      { label: 'Facilitator notes and answer key', href: '/data/guides/fs-api-clinic-facilitator.md', modal: 'markdown', locked: true },
    ],
  },
  {
    id: 'fs-api-03-validation-testing-backend-swap',
    title: 'API Clinic 03 · Validation, Testing & the Backend Swap',
    topics: ['PUT versus PATCH', 'Contract tests', 'Cross-language clients', 'React and CORS', 'Persistence and ownership'],
    file: null,
    kind: 'note',
    track: 'full-stack-developer-job-ready',
    cohort: 1,
    active: true,
    date: null,
    resources: [
      { label: 'API engineering concept clinic', ctaLabel: 'Open engineering clinic', href: '/data/guides/fs-api-concept-clinic.md#clinic-3-validation-testing-and-the-backend-swap', modal: 'markdown', cardCta: true },
      { label: 'Worked cases and cohort practice', href: '/data/guides/fs-api-clinic-practice.md', modal: 'markdown' },
      { label: 'Full runnable Task API workbook', href: '/data/guides/fs-api-python-java-study.md', modal: 'markdown' },
      { label: 'Facilitator notes and answer key', href: '/data/guides/fs-api-clinic-facilitator.md', modal: 'markdown', locked: true },
    ],
  },
];

export default API_CONCEPT_CLINICS;
